import React, { useEffect, useRef, useState } from 'react'
import i18n from '~/i18n'
import { animateGenerationMark } from './generationMotion'

const STATUSES = ['drafting', 'building', 'content', 'styling', 'refining', 'waiting']

export default function GenerationLoading() {
    const [statusIndex, setStatusIndex] = useState(0)
    const markRef = useRef(null)
    const ns = 'templates:add.magicTools'
    const status = i18n.t(`${ns}.generationStatus.${STATUSES[statusIndex]}`)

    useEffect(() => animateGenerationMark(markRef.current), [])

    useEffect(() => {
        // These are illustrative stages, not progress reported by the generator.
        if (statusIndex === STATUSES.length - 1) return
        const timer = setTimeout(() => setStatusIndex((index) => index + 1), 8000)
        return () => clearTimeout(timer)
    }, [statusIndex])

    return (
        <div className='ai-create-wizard__loading ai-generation-loading' data-test='ai-create-generating'>
            <svg
                ref={markRef}
                className='ai-generation-loading__mark'
                xmlns='http://www.w3.org/2000/svg'
                width='56'
                height='64'
                viewBox='2 0 27.772 32'
                fill='currentColor'
                aria-hidden='true'
                focusable='false'
            >
                <g className='ai-generation-loading__band ai-generation-loading__band--top'>
                    <path d='M11.251 2.66667L6.61659 5.33333L2 2.66667L6.61659 0L11.251 2.66667Z' />
                    <path d='M15.8862 5.33332L11.2518 7.99999L6.61737 5.33332L11.2518 2.66666L15.8862 5.33332Z' />
                    <path d='M20.5201 8.00001L15.8857 10.6667L11.2513 8.00001L15.8857 5.33334L20.5201 8.00001Z' />
                    <path d='M25.154 10.6667L20.5195 13.3333L15.8851 10.6667L20.5195 8L25.154 10.6667Z' />
                    <path d='M29.7702 13.3333L25.1536 16L20.5192 13.3333L25.1536 10.6667L29.7702 13.3333Z' />
                    <path d='M29.7711 13.3333V18.6667L25.1545 21.3333V16L29.7711 13.3333Z' />
                    <path d='M6.61659 0V5.33333L2 8V2.66667L6.61659 0Z' />
                </g>
                <g className='ai-generation-loading__band ai-generation-loading__band--middle'>
                    <path d='M20.5195 18.6667V24L15.8851 26.6667V21.3333L20.5195 18.6667Z' />
                    <path d='M11.251 13.3333L6.61659 16L2 13.3333L6.61659 10.6667L11.251 13.3333Z' />
                    <path d='M15.8862 16L11.2518 18.6667L6.61737 16L11.2518 13.3333L15.8862 16Z' />
                    <path d='M20.5201 18.6667L15.8857 21.3333L11.2513 18.6667L15.8857 16L20.5201 18.6667Z' />
                    <path d='M6.61659 10.6667V16L2 18.6667V13.3333L6.61659 10.6667Z' />
                </g>
                <g className='ai-generation-loading__band ai-generation-loading__band--bottom'>
                    <path d='M11.2518 24V29.3333L6.61737 32V26.6667L11.2518 24Z' />
                    <path d='M11.251 24L6.61659 26.6667L2 24L6.61659 21.3333L11.251 24Z' />
                    <path d='M6.61659 21.3333V26.6667L2 29.3333V24L6.61659 21.3333Z' />
                </g>
            </svg>
            <p className='ai-generation-loading__status' role='status' aria-live='polite' aria-atomic='true'>
                <span key={statusIndex} className='ai-generation-loading__text'>
                    {status}
                    <span className='ai-generation-loading__shine' data-text={status} aria-hidden='true' />
                </span>
            </p>
            <p className='ai-generation-loading__hint'>{i18n.t(`${ns}.generatingHint`)}</p>
        </div>
    )
}
